var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{staticClass:"upload-demo",attrs:{"limit":1,"action":_vm.url,"on-change":_vm.handleChange,"on-success":_vm.success,"on-preview":_vm.previewFun,"on-remove":_vm.removeFun,"file-list":_vm.list}},[_c('el-button',{attrs:{"size":"mini","type":"success"}},[_vm._v("点击上传")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1951a37a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Oa/UploadFileOa.vue
// module id = null
// module chunks = 